import React from 'react';
import LocationsTable from './LocationsTable';
import { FinanceBreakdownRowDto, FinanceTotalsDto } from '../../../../common/interfaces/invoicing.interface';

/**
 * A location by group: the same columns as the kindergarten by location, each group with
 * its price list under its name, and red only where something is more than 30 days late.
 */
const GroupsTable: React.FC<{
  rows: FinanceBreakdownRowDto[];
  totals: FinanceTotalsDto;
  totalLabel: string;
  onRowClick: (row: FinanceBreakdownRowDto) => void;
}> = props => <LocationsTable {...props} grain="group" />;

export default GroupsTable;
